import mixpanel from "mixpanel-browser"

export const MixpanelTracker = () => {

  const ENVIROMENT = process.env.NEXT_PUBLIC_NODE_ENV

  if (ENVIROMENT === "PROD") {
    mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN, {
      debug: ENVIROMENT === "DEV"
    })
  }

  const initTrackingSession = async sessionData => {
    if (ENVIROMENT === "PROD") {
      sessionData.userRoles.forEach(role => {
        sessionData[`$systemRole_${role}`] = role
      })

      mixpanel.identify(sessionData.id)
      mixpanel.people.set(
        {
          $id: sessionData.id,
          $email: sessionData.email,
          $name: sessionData.fullName,
          $systemRole: sessionData.userRoles,
          created_at: (new Date()).toISOString(),
          ...sessionData
        }
      )
    }
  }

  const trackEvent = async (eventName, metadata) => {
    if (ENVIROMENT === "PROD") mixpanel.track(eventName, metadata)
  }

  return { initTrackingSession, trackEvent }
}